/* Generated into assets/tfs-order-source.js by scripts/build-tfs-order-source.mjs. */
(function (sources) {
  'use strict';
  if (window.hsTfsOrderSource) return;

  var FIRST_KEY = 'hs_tfs_order_source_first';
  var LAST_KEY = 'hs_tfs_order_source_last';
  var HANDOFF_KEY = 'hs_tfs_order_source_handoff';
  var FIRST_PROPERTY = 'properties[_tfs_source_first]';
  var LAST_PROPERTY = 'properties[_tfs_source_last]';

  function valid(value) {
    if (typeof value !== 'string') return false;
    if (sources.indexOf(value) !== -1) return true;
    return sources.indexOf('email:*') !== -1 && /^email:[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value);
  }
  function read(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }
  function touch(value) {
    if (!valid(value)) return;
    if (!valid(read(FIRST_KEY))) write(FIRST_KEY, value);
    write(LAST_KEY, value);
  }
  function stamp(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', name);
      form.appendChild(input);
    }
    input.setAttribute('value', value);
    input.value = value;
  }
  function isAddForm(form) {
    return form && form.tagName === 'FORM' &&
      (form.getAttribute('is') === 'product-form' ||
        (form.getAttribute('action') || '').indexOf('/cart/add') > -1);
  }
  function onSubmit(event) {
    var form = event.target;
    if (!isAddForm(form)) return;
    var first = read(FIRST_KEY);
    var last = read(LAST_KEY);
    if (!valid(first) || !valid(last)) return;
    stamp(form, FIRST_PROPERTY, first);
    stamp(form, LAST_PROPERTY, last);
  }

  var path = window.location.pathname.replace(/\/$/, '');
  var isGame = path === '/pages/tea-flight-shuffle';
  var isCollection = path === '/pages/my-tea-collection';
  if (isGame || isCollection) {
    var landing = new URLSearchParams(window.location.search).get('src');
    touch(valid(landing) && (landing === 'khub-discover' || landing.indexOf('email:') === 0)
      ? landing : isGame ? 'tfs-page' : 'collection');
  } else if (path === '/pages/tea-discovery-wheel') {
    touch('wheel');
  } else if (path === '/pages/rewards' && document.querySelector('.rw-tfs')) {
    touch('rewards');
  } else if (/^\/products\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(path)) {
    try {
      var handoff = window.localStorage.getItem(HANDOFF_KEY);
      window.localStorage.removeItem(HANDOFF_KEY);
      if (handoff) {
        var transfer = JSON.parse(handoff);
        var age = Date.now() - transfer.at;
        if (typeof transfer.at === 'number' && age >= 0 && age < 120000 &&
            valid(transfer.first) && transfer.last === 'view-tea' && valid(transfer.last)) {
          touch(transfer.first);
          touch(transfer.last);
        }
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && typeof target.closest === 'function' &&
      target.closest('#hsgCta, .hs-gacha__tile-shop');
    if (!link) return;
    touch('view-tea');
    try {
      var next = new URL(link.href, window.location.href);
      if (next.origin !== window.location.origin ||
          !/^\/products\/[a-z0-9]+(?:-[a-z0-9]+)*\/?$/.test(next.pathname)) return;
      var first = read(FIRST_KEY);
      if (valid(first)) window.localStorage.setItem(HANDOFF_KEY,
        JSON.stringify({ first: first, last: 'view-tea', at: Date.now() }));
    } catch (e) {}
  }, true);
  document.addEventListener('submit', onSubmit, true);
  window.hsTfsOrderSource = { touch: touch };
})(["tfs-page","collection","wheel","rewards","view-tea","perk-redemption","khub-discover","email:*"]);
